import * as React from 'react';
import { useHistory, useLocation, useParams } from 'react-router';

/* export enum ArticlePageType {
  DEFAULT = 'DEFAULT',
  LEISURE = 'LEISURE'
} */

interface DefaultFilterArgs {}

interface GetArticlesFilterArgs extends DefaultFilterArgs {
  excludeFirst?: boolean;
}

interface GetArticleFilterArgs extends DefaultFilterArgs {}

interface GetPaginatedArticlesFilterArgs extends DefaultFilterArgs {
  page: number;
}

export interface ISeo {
  title: string;
  description: string;
  image: string;
}

export interface IMainPage {
  /*  type?: ArticlePageType; */
  image?: string;
  imageOpacity?: number;
  title?: string;
  description: string;
  showSteps: boolean;
  pathname: string;
}

export interface IArticle {
  id: number;
  /*   type: ArticlePageType; */
  image: string;
  imageOverlay: string;
  video?: string;
  title?: string;
  ingress?: string;
  quote?: string;
  content?: string;
  slug: string;
  link: string;
  card: {
    title: string;
    description: string;
    buttonLabel?: string;
  };
  seo: ISeo;
}

interface IArticleContext {
  main: () => IMainPage | null;
  articles: (/* args: GetArticlesFilterArgs */) => IArticle[];
  getArticle: (/* args: GetArticleFilterArgs */) => IArticle | null;
  getFirstArticle: () => IArticle | null;
  getPaginatedArticles: (args: GetPaginatedArticlesFilterArgs) => IArticle[];
  getArticlePageType: () => string;
  getArticleCountByType: () => number;
}

export const InflationContext = React.createContext<IArticleContext>({
  main: () => null,
  articles: () => [],
  getArticle: () => null,
  getFirstArticle: () => null,
  getPaginatedArticles: () => [],
  getArticlePageType: () => '',
  getArticleCountByType: () => 0
});

export const InflationContextProvider: React.FC = ({ children }) => {
  const history = useHistory();
  const params = useParams<{ type?: string; slug?: string }>();
  const location = useLocation();

  history.listen(() => {
    window.scroll(0, 0);
  });

  const main: IMainPage[] = [];

  const articles: IArticle[] = [
    {
      id: 0,
      type: '',
      seo: {
        title: 'Stor interesse for familieboliger',
        description:
          'I områdene Nore Neset og Lysefjorden har det vært en økning i antall bergensere på visning.',
        image:
          'https://cdn.reeltime.no/pm_assets/kampanjer/headsup/Vidar-Hjertaas.jpg'
      },
      /*       card: {
        title: 'Komme i gang',
        description:
          'Eiendomsmegler Christer Vikebø i PrivatMegleren har gitt råd og oppfølging til eiendomsselgere i over tyve år. Han mener utvilsomt at en god start er nødvendig om du skal få et godt resultat.',
        buttonLabel: 'Til episode'
      }, */
      title: 'Stor interesse for familieboliger',
      video: 'https://player.vimeo.com/video/672745753?amp;loop=0&background=0',
      ingress: `
      <p><b>I områdene Nore Neset og Lysefjorden har det vært en økning i antall bergensere på
      visning. En trend vi tror vil fortsette når E39 åpnes. Da vil folk oppleve den korte veien
      selv, noe som vil gjøre valget enda enklere. Her får du mer for pengene enn i nabokommunen vår, Bergen, sier eiendomsmegler i
      PrivatMegleren, Vidar Haugland Hjertaas. Han mener at etterspørselen i familiebolig-
      segmentet vil skille seg positivt ut, både i Lysefjorden og på Nore Neset.</b></p>
      
      `,
      /*       quote:
        'Du kjøper tross alt ikke et hyllevareprodukt, men en personlig rådgiver', */
      content: `
      <h4>«Alle» veier fører snart til Lysefjorden</h4><img class="inline-image" src="https://cdn.reeltime.no/pm_assets/kampanjer/headsup/Vidar-Hjertaas.jpg" alt="artikkel-bilde" />
      <p>Lysefjorden er et spennende utviklingsområde og er allerede et godt sted å bo for familien.
      Mange eiendommer i området har gode solforhold og sjøutsikt, samtidig som det er godt
      etablert med barnehager, skoler og idrettsanlegg i nærheten.</p>
      <p>Lysefjorden oppleves som stadig mer sentralt, både med etableringen av Lyseparken og
      E39. Enda en reguleringsplan med et nytt veistrekke, er gode nyheter for alle som bor i
      området.</p>

      <p>Det ligger jo blant annet en reguleringsplan av et veistrekk fra avkjørsel mot Drange
      til Endelausmarka og Lyseparken. Dette vil være med på å gjøre Lysefjorden til et
      mer sentralt sted. Det kan også nevnes at det ligger flere reguleringsplaner for
      fremtidig boligbebyggelse. Det at Bjørnafjorden kommune nylig har sikret seg en
      større eiendom i Lysefjorden, viser at dette er et område kommunen har stor tro på,
      sier Hjertaas.</p>

      <h4>«Alle» har tro på Nore Neset</h4>
      <p>Nore Neset er allerede et godt sted å bo for familien, med alt av fasiliteter i nærområdet.
      Med kort vei til nye E39 og reguleringsplaner for fremtidig boligbebyggelse, er det ikke bare
      de lokale kreftene som har tro på fremtiden her, kjente idrettsstjerner etablerer seg også i
      området.</p>
      <p>Nore Neset har barnehage, barneskole, ungdomsskole, idrettshall og
      kunstgressbaner. I tillegg har vi nylig fått enda en ny hall, samt utendørs padelbaner.
      Det er heller ikke bare lokale krefter som har tro på Nore Neset. I skrivende stund
      holder Inter Padel med de tidligere idrettsstjernene Bjørn Maaseide, Jan Kvalheim og
      Thor Hushovd i spissen på å etablere seg på nettopp Nore Neset, sier Hjertaas.</p>
      <h4>Stor prisvekst i begge områder</h4>
      <p>De siste ti årene har prisveksten i både Lysefjorden og Nore Neset vært jevnt over høy. Om
      man har bodd i boligen sin relativt lenge kan man altså fortsatt få godt betalt for boligen sin,
      selv om markedet ser ut til å ha en liten korreksjon.</p>
      <p>På Nore Neset solgte jeg en mindre enebolig på 118 kvm. for litt over fem millioner
      kroner, nå i sommer. Første gang den ble omsatt i 2013, gikk den for ca. tre millioner.
      På ti år ser vi altså en prisstigning på over 67%.</p>
      <p>I Lysefjorden ser vi den samme tendensen. Der solgte jeg nettopp en enebolig på
      259 kvm. for 8,4 millioner kroner. I 2014 ble samme enebolig solgt for rett under fem
      millioner. Det tilsvarer en prisstigning på 68 % for akkurat denne eneboligen, sier
      Hjertaas.</p>
      <h4>Spar tusenlapper med refinansiering</h4>
      <p>En prisstigning er gode nyheter, også for dem som ikke har tenkt å selge. Om det er
      lenge siden du har fått en verdivurdering av egen bolig, kan det være lurt å be om en
      e-takst. En e-takst kan brukes til å refinansiere banklånet. I disse tider med
      renteøkning er det smart å forhøre seg om man har de beste vilkårene. Man kan
      spare mange tusen kroner på det. Det er bare å ta kontakt med meg dersom du
      ønsker bistand til dette eller vil ha kontakt med en svært dyktig bankrådgiver som er i
      vårt nettverk, avslutter Hjertaas.</p>
      <p>Ventetiden på nye E39 er endelig over. Vi feirer med å gi bort gratis e-takst til alle
      innbyggerne med eiendom i Bjørnafjorden.Ta kontakt, så hjelper vi deg.</p>
      `,
      image:
        'https://cdn.reeltime.no/pm_assets/kampanjer/headsup/Vidar-Hjertaas.jpg',

      imageOverlay: '',
      slug: 'artikkel1',
      link: '/kampanje/vikoyr/main/artikkel1'
    },
    {
      id: 1,
      type: '',
      seo: {
        title: 'Mye kos i Os',
        description:
          'De siste årene har det vært en økende interesse for dyrere eiendommer i Bjørnafjorden og i Os.',
        image:
          'https://cdn.reeltime.no/pm_assets/kampanjer/headsup/Arild-Vikoyr.jpg'
      },
      /*       card: {
        title: 'Befaring',
        description:
          'En befaring er ikke bare til for at megleren skal bli kjent med eiendommen din. Det er også en gyllen anledning for deg å erfare hvordan megleren presterer – allerede før oppdraget har startet.',
        buttonLabel: 'Til episode'
      }, */
      title: '',
      video: 'https://player.vimeo.com/video/672745794?amp;loop=0&background=0',
      ingress: ``,
      /*       quote:
        'En dreven megler vet hva som skal til for å utløse et salg i ditt område', */
      content: `
      <h4>Mye kos i Os</h4><img class="inline-image" src="https://cdn.reeltime.no/pm_assets/kampanjer/headsup/Arild-Vikoyr.jpg" alt="artikkel-bilde" />
      <p>De siste årene har det vært en økende interesse for dyrere eiendommer i Bjørnafjorden og i
      Os. Vi skal ikke selge skinnet før bjørnen er skutt, men det er klart at vi mener at nye E39 vil
      spille positivt inn på etterspørselen etter denne type eiendommer i bygda, sier Arild Vikøyr,
      eiendomsmegler og daglig leder av PrivatMegleren Vikøyr &amp; Brandt.</p>
      <h4>Folk vil kose seg i Os</h4>
      <p>En eiendom til over åtte millioner kroner karakteriseres som dyrt i Os, fra 10 millioner og
      oppover befinner vi oss i luksussegmentet.</p>
      <p>Vi blir jevnlig kontaktet av kunder med spørsmål om vi har gode eiendommer med
      god beliggenhet tilgjengelig. Budsjettet er ofte et sted mellom 8-10 millioner kroner.
      Dette opplever vi stadig oftere enn før, sier Vikøyr.</p>
      <h4>Beliggenhet, beliggenhet og beliggenhet</h4>
      <p>De tre siste årene er det solgt 37 eiendommer i de øverste prisklassene i Os. Av dem er hele
      29 eiendommer solgt til over åtte millioner kroner, resten i luksussegmentet. Så langt i år er
      det solgt to eiendommer i Os til over 10 millioner kroner.</p>
      <p>Den ene var en enebolig i Sundøyhagen og den andre en leilighet i Mobergsbakken.
      Jeg var så heldig å ha begge disse salgene. Begge var eiendommer som skilte seg
      godt ut fra «normalen». Fellesnevneren var klisjeen «beliggenhet, beliggenhet og
      beliggenhet», sier Vikøyr.</p>
      <p>Innbyggertallet i hele kommunen har steget jevnt i årevis. For 15-20 år siden fantes det
      knapt leiligheter i Os. I dag har dette markedet eksplodert.</p>
      <p>De dyreste leilighetene i Os Sjøfront selges for samme, eller høyere pris, enn
      leiligheter på Måseskjæret i Bergen. Som prosjektmegler har det vært spennende å
      se urbaniseringen som skjer flere plasser i området, sier Vikøyr.</p>
      <h4>Nybygg og nye folk i kommunen.</h4>
      <p>Innbyggertallet i Bjørnafjorden er ventet å vokse til ca. 30 000 innen 2050. Det er ca. 5000
      flere innbyggere enn i dag. Denne veksten tilsier at det må bygges enda flere boliger i
      bygda.</p>
      <p>Vi kan snakke om rundt 1.500 nye boliger, men jeg har tro på en enda høyere vekst i
      Bjørnafjorden. Vi bor i den vakreste bygda i hele Vestland fylke, sier Vikøyr og
      tilføyer at han anser seg selv som noe inhabil i akkurat dette spørsmålet. Alle som
      bor i Os burde uansett få en ny verdivurdering for å se om tunnelen og nye E39 kan
      ha gitt en positiv effekt på eiendomsverdien. Det er bare å ta kontakt med oss i
      PrivatMegleren på Os, så hjelper vi deg, avslutter Vikøyr.</p>
      <p>Ventetiden på nye E39 er endelig over. Vi feirer med å gi bort gratis e-takst til alle
      innbyggerne med eiendom i Bjørnafjorden.Ta kontakt, så hjelper vi deg.</p>
      `,
      image:
        'https://cdn.reeltime.no/pm_assets/kampanjer/headsup/Arild-Vikoyr.jpg',
      imageOverlay: '',
      slug: 'artikkel2',
      link: '/kampanje/vikoyr/main/artikkel2'
    }
  ];

  /*   const getArticlePageType = () => {
    switch (params.type) {
      case 'inflation':
        return ArticlePageType.LEISURE;
      default:
        return ArticlePageType.DEFAULT;
    }
  }; */

  const getMain = () => {
    return main.find((item) => item.pathname === location.pathname) || null;
  };

  const getFirstArticle = () => {
    return articles[0];
  };

  /* Picking out all episodes that is not of id 0 */
  const getArticles = (args: GetArticlesFilterArgs) => {
    const filtered = articles;
    if (args?.excludeFirst) {
      filtered.splice(0, 1);
    }
    return filtered;
  };

  /* Picking out a spesific episode based on link url string */
  const getArticle = (/* args: GetArticleFilterArgs */) => {
    return articles.find((item) => item.slug === params.slug);
  };

  /*   const getArticleCountByType = () => {
    const type = getArticlePageType();
    return articles.filter((item) => item.type === type).length;
  }; */

  /* Showing 0-2 indexes in array (manipulating copied array with ...) */
  /*   const getPaginatedArticles = (args: GetPaginatedArticlesFilterArgs) => {
    const type = getArticlePageType();
    return [...articles.filter((item) => item.type === type)].splice(
      args.page * 2,
      2
    );
  };
 */
  return (
    /* Implements episode functions in the context provider */
    <InflationContext.Provider
      value={{
        main: getMain,
        articles: getArticles,
        getArticle,
        getFirstArticle
        /*   getPaginatedArticles, */
        /*   getArticlePageType, */
        /*   getArticleCountByType */
      }}
    >
      {children}
    </InflationContext.Provider>
  );
};
